module.exports = __webpack_public_path__ + "static/media/NutzungsbedingungenGs.6e7cd818.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/NutzungsbedingungenGs.pdf
// module id = 1516
// module chunks = 0